export default {
  siteId: "15",
  siteName: "br",
  site: "br",
  lang: "Portuguese",
  activityName: "",
  productList: "Lista de produtos",
  POST: "POST",
  Score: "Pontuação",
  Title: "Título",
  Review: "Avaliação",
  Media: "Mídia",
  rateLevel1: "Muito insatisfeita",
  rateLevel2: "Um pouco insatisfeita",
  rateLevel3: "Nem satisfeita, nem insatisfeita",
  rateLevel4: "Um pouco satisfeita",
  rateLevel5: "Muito satisfeita",
  "LEAVE A REVIEW": "Deixe uma avaliação",
  "Please enter a star rating for this review":
    "Escolha a quantidade de estrelas para a avaliação",
  "Review’s title can’t be empty":
    "Os campos de título e mensagem não podem estar vazios",
  "Review’s body can’t be empty":
    "Os campos de título e mensagem não podem estar vazios",
  "Please upload a media less than 10 megabytes":
    "O arquivo deve ter no máximo 10 MB",
  "Please upload a media less than 20 megabytes":
    "O arquivo deve ter no máximo 10 MB",
  "THANK YOU FOR YOUR COMMENTS": "MUITO OBRIGADA PELA AVALIAÇÃO",
  "We love seeing reviews":
    "Não se esqueça de adicionar auservice@cupshe.com ao seu catálogo de endereços para ficar por dentro de todas as novidades!",
  "fill out":
    "Bitte füllen Sie das folgende Formular aus und geben Sie Ihre Bewertung ab.",
  "SUBMIT YOUR REVIEW": "ENVIAR AVALIAÇÃO",
  shopping:
    "https://br.cupshe.com/collections/mais-vendidos?utm_source=automatic&utm_medium=email&utm_campaign=review_shopping",
  mailto: "customercare",
  pageTitle: "Avaliações de clientes",
  "VIEW COMMENTS": "Ver Avaliação",
  "GO SHOPPING": "Começar a comprar",
  mailText: `Para receber todas as últimas novidades por e-mail, adicione <a style="color:#333;text-decoration: underline;" class="c-muli-light" href="mailto:{mailto}{domain}">{mailto}{domain}</a> ao seu catálogo de endereços.`,
  email: "E-Mail",
  "contact us": "Fale conosco",
  contactUrl:
    "https://br.cupshe.com/pages/fale-conosco?utm_source=automatic&utm_medium=email&utm_campaign=review_contact",
  chat: "chat",
  next: "next",
  copyright: "Copyright © {year} Cupshe {sitename}, Todos os direitos reservados.",
};
